import { useMutation } from "@apollo/client";
import { GET_FLOORING_VARIATIONS } from "graphql/query/flooring-gql";
import {
  FLOORING_VARIATION_UPDATE,
  FLOORING_VARIATION_CREATE,
} from "graphql/mutation/flooring-gql";
import {
  successNotification,
  errorNotification,
} from "components/request-result";

const useMutationFlooringVariationCreateUpdate = (
  id: string | undefined,
  variables: Record<string, any>
) =>
{
  const FLOORING_VARIATION_CREATE_UPDATE = id
    ? FLOORING_VARIATION_UPDATE
    : FLOORING_VARIATION_CREATE;
  const flooringVariationCreateUpdate = id
    ? "flooringVariationUpdate"
    : "flooringVariationCreate";

  const [ _setFlooringVariationCreateUpdate, { loading } ] = useMutation(
    FLOORING_VARIATION_CREATE_UPDATE,
    {
      update(cache, { data })
      {
        const {
          [ flooringVariationCreateUpdate ]: { label, message },
        } = data;

        successNotification({
          title: label,
          description: message,
        });
      },
      onError(error)
      {
        errorNotification(error);
      },
      refetchQueries: [
        {
          query: GET_FLOORING_VARIATIONS,
          variables,
        },
      ],
    }
  );

  const handleCreateUpdate = async (options: { variables: Record<string, any> }) =>
  {
    await _setFlooringVariationCreateUpdate(options);
  };

  return {
    _setFlooringVariationCreateUpdate: handleCreateUpdate,
    loadingMutationFlooringVariationCreateUpdate: loading,
  };
};

export default useMutationFlooringVariationCreateUpdate;
